import { render, staticRenderFns } from "./SettingsConnection.vue?vue&type=template&id=2da89220&"
import script from "./SettingsConnection.vue?vue&type=script&lang=js&"
export * from "./SettingsConnection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports